import React, { useState } from 'react';
import { string, node, func } from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { r_times } from '@fiverr-private/icons';
import { white } from '@fiverr-private/sass/helpers/index';

import styles from './style.module.scss';

const Notice = ({
    className = '',
    message,
    onDismiss = Function.prototype,
    children
}) => {
    const [show, setShow] = useState(true);

    const onCloseClick = () => {
        setShow(false);
        onDismiss();
    };

    return show ? (
        <div className={classNames(styles.holder, className)}>
            {message}
            {children}
            <Icon className={styles.close}
                color={white}
                onClick={onCloseClick}>{r_times}</Icon>
        </div>
    ) : null;
};

Notice.propTypes = {
    className: string,
    onDismiss: func,
    message: node,
    children: node
};

export default Notice;
